import ClientMultiSelect from './ClientMultiSelect';

export default ClientMultiSelect;
